import { render, staticRenderFns } from "./GiffsPicker.vue?vue&type=template&id=1feb5404&"
import script from "./GiffsPicker.vue?vue&type=script&lang=js&"
export * from "./GiffsPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports